import React, {useLayoutEffect, useRef, useState} from "react";
import ReactHtmlParser, {convertNodeToElement} from 'react-html-parser';

import {AOJSlider} from '../components/AOJSlider';
import { useGlobalState, isMobile } from '../state';

export default function ProductFilters(props) {
    const [filtersHTML] = useState(document.querySelector('#o-filters-block').innerHTML);
    const [filtersConfig, setFiltersConfig] = useGlobalState('filters');
    const [byoStep] = useGlobalState('byoStep');
    const [dShape, setDShape] = useGlobalState('dShape');
    const [BYOSelectedDiamondID] = useGlobalState('BYOSelectedDiamondID');
    const [, setSortBy] = useGlobalState('sortBy');
    const [, setSortDirection] = useGlobalState('sortDirection');

    const moreFiltersDivRef = useRef(null);
    const [moreFiltersExpanded, setMoreFiltersExpanded] = useState(false);
    const [mobileFiltersExpanded, setMobileFiltersExpanded] = useState(false);

    const [slidersRealTimeState, setSlidersRealTimeState] = useState({});
    useLayoutEffect(() => { setSlidersRealTimeState({}); }, [filtersConfig])

    useLayoutEffect(() => {
        if(document.querySelector('#' + byoStep.replace('detail', '') + '-crumb')) {
            document.querySelector('#' + byoStep.replace('detail', '') + '-crumb').className = 'active';
        }
    }, [])

    const onFilterSlide = (filterId, newValue) => {
        setFiltersConfig(prevFilters => {return {...prevFilters, [filterId]: {...filtersConfig[filterId], min: newValue[0], max: newValue[1]}}});
    }

    const onFilterInputChange = (event) => {
        const filterId = event.target.getAttribute('filterid'); if(!filterId) return;
        let value = event.target.value === '' ? '' : Number(event.target.value);
        value = value < filtersConfig[filterId].default_min ? filtersConfig[filterId].default_min : value;
        value = value > filtersConfig[filterId].default_max ? filtersConfig[filterId].default_max : value;
        setFiltersConfig(prevFilters => {return {...prevFilters, [filterId]: {...filtersConfig[filterId], [event.target.id.replace('slider-input-', '')]: value}}});
    }

    const onFilterToggle = (filterId, filterValue) => {
        let filterValues = filtersConfig[filterId] ? filtersConfig[filterId] : [];
        if(!filterValues.map(f => f.toLowerCase()).includes(filterValue)) {
            filterValues.push(filterValue);
        } else {
            filterValues = filterValues.filter((val) => val.toLowerCase() !== filterValue)
        }
        setFiltersConfig(prevFilters => {return {...prevFilters, [filterId]: filterValues}});

        if(filterId === 'shape') {//special case where we need to set the dshape as-well
            setDShape(filterValues.map(v => v.replaceAll('_', '-').toLowerCase()).join(','));
        }
    }

    const onMoreFiltersBtnClick = (moreFilterIDs) => {
        setMoreFiltersExpanded(!moreFiltersExpanded);
        moreFilterIDs.split(',').forEach((filterID) => {
            moreFiltersDivRef.current.querySelector(`#${filterID}`).style.display = moreFiltersExpanded ? 'none' : 'block'
        })
    }

    const onSortClick = (event) => {
        setSortBy(event.currentTarget.getAttribute('sort-by'))
        setSortDirection(event.currentTarget.getAttribute('sort-dir'))
    }

    const onMobileFiltersToggleBtnClick = (event) => {
        setMobileFiltersExpanded(!mobileFiltersExpanded);
        if(!mobileFiltersExpanded) {
            event.currentTarget.parentNode.parentNode.parentNode.querySelector('#dropdownFilters').style.display = 'initial';
            event.currentTarget.querySelector('#span-expandable').classList.remove('fa-plus');
            event.currentTarget.querySelector('#span-expandable').classList.add('fa-minus');
        }
        else {
            event.currentTarget.parentNode.parentNode.parentNode.querySelector('#dropdownFilters').style.display = 'none';
            event.currentTarget.querySelector('#span-expandable').classList.remove('fa-minus');
            event.currentTarget.querySelector('#span-expandable').classList.add('fa-plus');
        }
    }

    const onMobileDropdownClick = (event) => {
        const dropdown = event.target.nextElementSibling;
        dropdown.style.position = "fixed";
        dropdown.style.bottom = "-100vh";
        dropdown.style.left = "0";
        dropdown.style.right = "0";
        dropdown.style.width = "100%";
        dropdown.style.marginLeft =  "0";
        dropdown.style.zIndex = "1000004";
        dropdown.style.top = "auto";
        dropdown.style.paddingBottom = "32px";
        dropdown.style.paddingLeft = "16px";
        dropdown.style.paddingRight = "16px";
        dropdown.style.transition = "bottom 200ms ease-in-out";
        dropdown.style.maxHeight = "50vh";
        dropdown.style.overflowY =  "auto";
        dropdown.style.overflowX =  "hidden";

        if(dropdown.firstChild.nodeName !== 'DIV') {
            const dropdownHeader = document.createElement('div');
            dropdownHeader.style.display = 'flex';
            dropdownHeader.style.justifyContent = 'space-between';
            dropdownHeader.style.alignItems = 'center';
            dropdownHeader.style.paddingLeft = '16px';
            dropdownHeader.style.paddingRight =  '24px';
            dropdownHeader.innerHTML = `
                    <h3 style="color: #6fbf98;">${dropdown.parentElement.querySelector('button').innerText}</h3>
                    <h3 style="color: #6fbf98; font-size: 35px; cursor:pointer;" onclick="this.parentElement.parentElement.parentElement.classList.remove('open');">×</h3>
                `;
            dropdown.insertBefore(dropdownHeader, dropdown.firstChild);
        }

        requestAnimationFrame(() => {
            dropdown.style.bottom = 0;
        })
    }

    const resetFilters = () => {
        setFiltersConfig({
            retail_price: {
                min: filtersConfig['retail_price']['default_min'],
                max: filtersConfig['retail_price']['default_max'],
                default_min: filtersConfig['retail_price']['default_min'],
                default_max: filtersConfig['retail_price']['default_max'],
            },
            carat_weight: {
                min: filtersConfig['carat_weight']['default_min'],
                max: filtersConfig['carat_weight']['default_max'],
                default_min: filtersConfig['carat_weight']['default_min'],
                default_max: filtersConfig['carat_weight']['default_max'],
            },
        });
        setDShape([]);
    }

    return (
        <div>
            {ReactHtmlParser(filtersHTML, {
                transform: (node) => transformNode(node)
            })}
        </div>
    );

    function transformNode(node, isChild = false) {
        //sliders
        if(node.type === 'tag' && node.name === 'div' && node.attribs.class && node.attribs.class.includes('filter-slider')) {
            const filterId = node.attribs.id.toLowerCase().replace('_dropdown', '');
            const sliderStep = !isNaN(node.children[3].children[1].children[0].children[1].attribs['data-slider-step'])
                    ? parseFloat(node.children[3].children[1].children[0].children[1].attribs['data-slider-step'])
                    : 1;
            if(!slidersRealTimeState[filterId]) {
                slidersRealTimeState[filterId] = [filtersConfig[filterId].min, filtersConfig[filterId].max];
            }
            return <div class="button-group filter-button-group" id={node.attribs.id}>
                        <button onClick={ isMobile() ? onMobileDropdownClick : null} type="button" class="btn btn-inverse dropdown-toggle" data-toggle="dropdown" aria-expanded="false">{node.children[1].children[0].data} <div class="pull-right"><span class="caret"></span></div></button>
                        <ul class="dropdown-menu" onClick={(event) => event.stopPropagation()}>
                            <li>
                                <span>
                                  <AOJSlider
                                      value={[parseFloat(slidersRealTimeState[filterId][0]), parseFloat(slidersRealTimeState[filterId][1])]}
                                      min={filtersConfig[filterId]['default_min']}
                                      max={filtersConfig[filterId]['default_max']}
                                      step={sliderStep}
                                      onChange={(_, newValue) => setSlidersRealTimeState(prevState => {return {...prevState, [filterId] : newValue};})}
                                      onChangeCommitted={(_, newValue) => onFilterSlide(filterId, newValue)}
                                  />
                                  <div style={{display: "flex", justifyContent: "space-between"}}>
                                    <input filterid={filterId} id='slider-input-min' type="text" pattern={"/^\d*\.?\d*$/"} value={slidersRealTimeState[filterId][0]}  onChange={(event) => setSlidersRealTimeState(prevState => {return {...prevState, [filterId]: [event.target.value, prevState[filterId][1]] };})} onBlur={onFilterInputChange} style={{width: "70px", fontSize: "12px", marginTop: "6px", textAlign: "center"}}/>
                                    <input filterid={filterId} id='slider-input-max' type="text" pattern={"/^\d*\.?\d*$/"} value={slidersRealTimeState[filterId][1]}  onChange={(event) => setSlidersRealTimeState(prevState => {return {...prevState, [filterId]: [prevState[filterId][0], event.target.value] };})} onBlur={onFilterInputChange} style={{width: "70px", fontSize: "12px", marginTop: "6px", textAlign: "center"}}/>
                                  </div>
                                </span>
                            </li>
                        </ul>
                    </div>
        }
        //dropdowns
        if(node.type === 'tag' && node.name === 'ul' && node.attribs.id && node.attribs.id.includes('filter_')) {
            return <ul class="dropdown-menu" id={node.attribs.id} onClick={(event) => event.stopPropagation()}>
                {node.children.map((li) => {
                    if(!li.children || li.children.length < 1) return convertNodeToElement(li);

                    const filterId = node.attribs.id.replace('filter_', '');
                    let optionId = li.children[0].children[0].attribs.id.toLowerCase().replaceAll(' ', '_').replaceAll('-', '_');

                    //edge case
                    if(optionId === 'earthy_rustic_organic') optionId = 'earthy-rustic-organic';

                    const filterStyle = node.attribs.id === 'filter_shape' && BYOSelectedDiamondID !== '' && dShape !== '' ? { pointerEvents: 'none'} : null;

                    return <li style={{...filterStyle, opacity: filterStyle != null && dShape.toLowerCase() !== optionId ? 0.5 : 1}}>
                        <a {...li.children[0].attribs} onClick={() => onFilterToggle(filterId, optionId)} id={optionId} href={null} style={filterStyle}>
                            <input {...li.children[0].children[0].attribs} id={null} onChange={null} checked={!!(filtersConfig[filterId] && filtersConfig[filterId].map(f => f.toLowerCase()).includes(optionId))} style={filterStyle}/>
                            {li.children[0].children[1].data}
                            {li.children[0].children[2] ? convertNodeToElement(li.children[0].children[2]) : null}
                            {li.children[0].children[3] ? convertNodeToElement(li.children[0].children[3]) : null}
                        </a>
                    </li>
                })}
            </ul>
        }
        //sort buttons
        if(node.type === 'tag' && node.name === 'li' && node.attribs.class && node.attribs.class.includes('sort_by')) {
            return <li {...node.attribs} style={{cursor: 'pointer'}} onClick={onSortClick}><a  {...node.children[0].attribs} href={null}>{node.children[0].children[0].data}</a></li>
        }
        //more filters
        if(node.type === 'tag' && node.name === 'div' && node.attribs.id && node.attribs.id === 'moreFiltersDisplayContainer') {
            return <div {...node.attribs} ref={moreFiltersDivRef}>
                {node.children.filter(c => c.type === 'tag').map((child) => {
                    child.attribs.style = 'display: none;';
                    child.attribs.class += ' col-md-2 col-sm-3 col-xs-12';
                    return transformNode(child, true);
                })}
            </div>
        }
        //more filters btn
        if(node.type === 'tag' && node.name === 'button' && node.attribs.id && node.attribs.id === 'filters_more_btn') {
            return <button type="button" class="btn btn-inverse dropdown-toggle" id='filters_more_btn' onClick={() => onMoreFiltersBtnClick(node.attribs['more-filter-ids'])}><i class="fa fa-plus"></i> &nbsp;More Filters</button>
        }
        //mobile expand/collapse filters button
        if(node.type === 'tag' && node.name === 'button' && node.attribs.id && node.attribs.id === 'filter_button') {
            return <button {...node.attribs} onClick={onMobileFiltersToggleBtnClick}>{node.children.map((child) => convertNodeToElement(child))}</button>
        }
        //mobile open dropdown button
        if(node.type === 'tag' && node.name === 'button' && node.attribs.class && node.attribs.class.includes('dropdown-toggle')) {
            return <button onClick={ isMobile() ? onMobileDropdownClick : null} type="button" class="btn btn-inverse dropdown-toggle" data-toggle="dropdown" aria-expanded="false">{node.children[0].data} <div class="pull-right"><span class="caret"></span></div></button>
        }
        //labels
        if(node.type === 'tag' && node.name === 'div' && node.attribs.id && node.attribs.id === 'addLabels') {
            return <div className="col-sm-12" id="addLabels">
                        {/*slider labels*/}
                        <span id="PriceL">
                            {Object.entries(filtersConfig)
                                .filter(([filterId, filterValues]) => (filterId === 'retail_price' || filterId === 'carat_weight') && (filterValues.min !== filterValues.default_min || filterValues.max !== filterValues.default_max))
                                .map(([filterId, filterValues]) => {
                                    return <span className="label label-success" id="priceL" style={{marginLeft: "10px"}}>
                                               {filterId === 'retail_price' ? '$' : ''}{filterValues.min} - {filterId === 'retail_price' ? '$' : ''}{filterValues.max}
                                               <a className="clos" style={{marginLeft: "5px"}}><span onClick={() => onFilterSlide(filterId, [filterValues.default_min, filterValues.default_max])}>X</span></a>
                                           </span>
                                })}
                        </span>
                        {/*dropdown labels*/}
                        <span id="contentHere" style={{lineHeight: "33px"}}>
                            {Object.entries(filtersConfig)
                                .filter(([filterId, filterValues]) => filterId !== 'retail_price' && filterId !== 'carat_weight' && filterId !== 'one_of_a_kind')
                                .map(([filterId, filterValues]) => {
                                    return filterValues.filter(fv => !fv.startsWith('!')).map((filterValue) =>
                                        <span className="label label-success" id={'label_' + filterValue} filter-id={filterId} style={{marginLeft: "10px"}}>
                                            <span style={{textTransform: "uppercase"}}>{filterId === 'metal_code' ? mapMetalCodeToLabel(filterValue) : filterValue.replaceAll('_', ' ')}</span>
                                            {(!(filterId === 'shape' &&  BYOSelectedDiamondID !== '' && dShape !== '') || filterId !== 'shape') &&
                                                <a className="clos" style={{marginLeft: "5px"}}><span id="CLASSIC_span" onClick={() => onFilterToggle(filterId, filterValue)}>X</span></a>
                                            }
                                        </span>
                                    )
                            })}
                        </span>
                        {/*clear all btn*/}
                        <span id="clearAll">
                            {(//only show the btn if we have filters configured
                                Object.entries(filtersConfig).filter(([filterId, filterValues]) => (filterId === 'retail_price' || filterId === 'carat_weight') && (filterValues.min !== filterValues.default_min || filterValues.max !== filterValues.default_max)).length > 0 ||
                                Object.entries(filtersConfig).filter(([filterId, filterValues]) => filterId !== 'retail_price' && filterId !== 'carat_weight' && filterId !== 'one_of_a_kind' && filterValues.find(fv => !fv.startsWith('!'))).length > 0
                            ) &&
                                <span className="label label-success clearAll" onClick={resetFilters} style={{marginLeft: "10px"}}>Clear all</span>
                            }
                        </span>
                   </div>
        }

        if(isChild) {
            const el = convertNodeToElement(node);
            if(node.children && !(node.name === 'img' || node.name === 'input')) {
                el.props.children = node.children.map((child) => transformNode(child, true))
            }
            return el;
        }
    }

    function mapMetalCodeToLabel(filterValue) {
        switch(filterValue.toUpperCase()) {
            case 'P': return 'Platinum';
            case 'R': return 'Rose Gold';
            case 'W': return 'White Gold';
            case 'Y': return 'Yellow Gold';
            case 'TT': return 'Two Tone';
        }
    }
}
